import { HttpHeaders } from '@angular/common/http';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { UpsellOffers } from 'src/app/model/page/sandbox-page';
import {
  AirlineOffersScreenRequest,
  FareGroup as OtherFareGroup,
  FareList,
  Flight,
  OfferItem as airLineOfferRequestOfferItem,
  OrderItem,
  OriginDestination,
  Passenger as OtherPassenger,
  Preference
} from 'src/app/model/request/airline-offers-screen-request';
import { SearchFlightsScreenRequest } from 'src/app/model/request/search-flights-screen-request';
import {
  Query as QuerySeatSelection,
  SBody as SBodySeatSelection,
  SeatAvailabilityRQ,
  SeatSelectionScreenRequest,
  SEnvelope as SEnvelopeSeatSelection
} from 'src/app/model/request/seat-selection-screen-request';
import {
  AirlineOffer,
  AirlineOffersScreen,
  BoundAirlineOffer as OtherBoundAirlineOffer,
  FlightDetail as OtherFlightDetail,
  OfferItems,
  Passenger as AirlineOfferPassenger,
  PriceDetail
} from 'src/app/model/screen/airline-offers-screen';
import { ConfirmBookingScreen, FareList as ConfirmBookingFareList } from 'src/app/model/screen/confirm-booking-screen';
import { AirlineOfferBase, BaggagePieceDimension, BoundAirlineOffer, FareGroup, FlightDetail, IconsStatus, OfferPriceScreen, Rule } from 'src/app/model/screen/offer-price-screen';
import { OtherOffers } from 'src/app/model/screen/other-offers';
import { Passenger, PassengerDetailScreen } from 'src/app/model/screen/passenger-detail-screen';
import { SeatSelectionScreen } from 'src/app/model/screen/seat-selection-screen';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { ApiService } from 'src/app/service/api.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';

@Component({
  selector: 'app-offer-price-screen',
  templateUrl: './offer-price-screen.component.html',
  styleUrls: ['./offer-price-screen.component.scss']
})
export class OfferPriceScreenComponent implements OnInit {
  flightLogoMap = new Map();
  rulesList: any;
  public rulesIds: any = [];
  public fareRulesIds: any = [];
  public fareRulesSegmentList: any = [];
  public refundableInd: any;
  public changeFeeInd: any;
  public baCarryOnBag: any;
  public baCheckBag: any;
  public remarkText: any;
  public cancelFeeInd: any;
  baggagesIds: any[] = [];
  bags: any;
  public baggageList: any[] = [];
  public bagQuantity = '0';
  public carryOnBagCount: number[] = [];
  public checkedBagCount: number[] = [];
  public fareDetails: FareGroup[] = [];
  availableOtherOffers: UpsellOffers[] = [];
  airlineOfferScreen: AirlineOffersScreen = {} as AirlineOffersScreen;
  offerPriceScreen: OfferPriceScreen = {} as OfferPriceScreen;
  passengerDetailScreen: PassengerDetailScreen = {} as PassengerDetailScreen;
  confirmBookingScreen: ConfirmBookingScreen = {} as ConfirmBookingScreen;
  baggagePieceDimension: BaggagePieceDimension = {} as BaggagePieceDimension;
  airlineOffersScreenRequest: AirlineOffersScreenRequest = {} as AirlineOffersScreenRequest;
  seatSelectionScreenRequest: SeatSelectionScreenRequest = {} as SeatSelectionScreenRequest;

  selectedAdultRefIds: any;
  public alphabetsOrderName = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF'];
  public selectedSegmentQueryDetail = {} as QuerySeatSelection;
  public isOfferScreenMapped: boolean = false;
  public displayConfirmBookingScreen: boolean = false;
  public offerScreenResponseId: any;

  offerPriceDataList: any = [];
  offerPricePricedOffer: any = {};

  flightSegmentIds: any = [];
  flightSegmentList: any = [];

  flightIds: any = [];
  flightList: any = [];

  priceClassList: any = [];
  priceClassListIds: any = [];

  fareGroupIds: any = [];
  fareGroupList: any = [];

  economyPriceClassCode: any;

  flightSegmentKey: any = 1;

  airlineLogos: [] = [];

  otherOffers: OtherOffers[] = [];

  isSMEUser: boolean = false;
  bookedClass: any;
  mappedSelectedOfferPriceFareCode: any[] = [];

  constructor(
    private sandboxPageStateService: SandboxPageStateService,
    private datePipe: DateFormatPipe,
    private apiService: ApiService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private contentfulService: ContentfulService,
    private localAssetReaderService: LocalAssetReaderService
  ) {
    const query = { 'fields.name': 'Airline Logos#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.airlineLogos = items[0]?.fields.jsonData;
      if (this.airlineLogos && Object.keys(this.airlineLogos).length > 0) {
        Object.entries(this.airlineLogos).forEach((entry) => {
          const [key, value] = entry;
          this.flightLogoMap.set(key, value);
        });
      }
    });
  }

  ngOnInit(): void {
    this.offerPriceScreen = this.sandboxPageStateService.getOfferPriceScreenData();
    this.airlineOfferScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    this.selectedAdultRefIds = this.airlineOfferScreen.adultRefsIds.join(' ');
    this.initOfferPriceScreenMapping();
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;
    this.availableOtherOffers = this.sandboxPageStateService.getUpsellOfersDetails();
  }

  getFlightLogoUrl(airlineName: string) {
    const flightLogoUrl = this.flightLogoMap.get(airlineName);
    if (flightLogoUrl) {
      return flightLogoUrl;
    }
    return '';
  }

  initOfferPriceScreenMapping() {
    if (this.offerPriceScreen.jsonData) {
      if (!this.offerPriceScreen.isMapped) {
        let offerPriceJSONDATA = this.offerPriceScreen.jsonData;
        let offerPriceScreenEnvelop = offerPriceJSONDATA['SOAP:ENVELOPE'];
        let offerPriceScreenBody = offerPriceScreenEnvelop['SOAP:BODY'][0];
        let offerPriceScreenPrices = offerPriceScreenBody['OFFERPRICERS']?offerPriceScreenBody['OFFERPRICERS'][0]:'';
        this.offerPriceDataList = offerPriceScreenPrices['DATALISTS']?offerPriceScreenPrices['DATALISTS'][0]:'';
        this.offerPricePricedOffer = offerPriceScreenPrices['PRICEDOFFER']?offerPriceScreenPrices['PRICEDOFFER'][0]:'';
        let offerPriceOfferItems = this.offerPricePricedOffer['OFFERITEM']?this.offerPricePricedOffer['OFFERITEM'][0]:'';
        let otherOffersDetails = offerPriceScreenPrices['OTHEROFFERS']?offerPriceScreenPrices['OTHEROFFERS'][0]:'';
        this.otherOffers = otherOffersDetails['OFFER'];
        // when long sell need to update offerIds
        let searchFlightFormValue = this.sandboxPageStateService.getSearchFlightFormValue();
        let isShortSell = searchFlightFormValue.shortSell;
        if (!isShortSell) {
          //write a code to replace selected offer
          this.updateOfferPriceScreenSelectedOfferItem();
        }
        //end
        this.flightSegmentList = this.offerPriceDataList['FLIGHTSEGMENTLIST'][0]['FLIGHTSEGMENT'];
        this.flightList = this.offerPriceDataList['FLIGHTLIST'][0]['FLIGHT'];
        this.offerScreenResponseId = offerPriceScreenPrices.SHOPPINGRESPONSEID[0].RESPONSEID[0];
        this.priceClassList = this.offerPriceDataList['PRICECLASSLIST'][0]['PRICECLASS'];
        this.fareGroupList = this.offerPriceDataList['FARELIST'][0]['FAREGROUP'];
        this.baggageList = this.offerPriceDataList['BAGGAGEALLOWANCELIST']?this.offerPriceDataList['BAGGAGEALLOWANCELIST'][0]['BAGGAGEALLOWANCE']:'';
        if (typeof this.offerPriceDataList['PENALTYLIST'] !== 'undefined') {
          this.rulesList = this.offerPriceDataList['PENALTYLIST'][0]['PENALTY'];
          this.mapPenaltyIds(this.rulesList);
        }
        if (typeof offerPriceOfferItems.FAREDETAIL !== 'undefined') {
          this.fareRulesSegmentList = offerPriceOfferItems.FAREDETAIL[0].FARECOMPONENT;
          this.mapFareRulesId(this.fareRulesSegmentList);
        }
        this.mapBaggageIds(this.baggageList);
        this.getBagsDetails(this.offerPricePricedOffer);
        this.mapFareGroup(this.fareGroupList);
        this.mapPriceClass(this.priceClassList);
        this.mapFlightSegmentIds(this.flightSegmentList);
        this.mapFlightIds(this.flightList);
        this.mapToOfferPriceScreen();

        if (typeof otherOffersDetails['OFFER'] !== 'undefined') {
          let upsellOffers = otherOffersDetails['OFFER'];
          this.mapOtherOffers(upsellOffers);
        } else {
          let availableOtherOffers: [] = [];
          this.sandboxPageStateService.updateUpsellOffersData(availableOtherOffers);
        }
      } else {
        this.isOfferScreenMapped = true;
        this.displayConfirmBookingScreen = true;
      }
    } else {
      // console.log('this.offerPriceScreen.jsonData is undefined');
    }
  }
  updateOfferPriceScreenSelectedOfferItem() {
    let pricedOfferIndex = 0;
    this.offerPricePricedOffer.OFFERITEM.forEach((pricedOffer: any) => {
      this.offerPriceScreen.selectedOfferItem[pricedOfferIndex].offerItemID = pricedOffer.$.OFFERITEMID;
      pricedOfferIndex++;
    });
  }
  mapPenaltyIds(penaltyList: any) {
    this.rulesIds = [];
    let penaltyListLength = penaltyList.length;
    if (penaltyListLength > 0) {
      penaltyList.forEach((penalty: any) => {
        this.rulesIds.push(penalty.$.OBJECTKEY);
      });
    }
  }

  mapFareRulesId(fareComponent: any) {
    this.fareRulesIds = [];
    let fareComponentLength = fareComponent.length;
    if (fareComponentLength > 0) {
      fareComponent.forEach((fare: any) => {
        this.fareRulesIds.push(fare.SEGMENTREFS[0]);
      });
    }
  }

  mapBaggageIds(baggageList: any) {
    this.baggagesIds = [];
    if (baggageList.length > 0) {
      baggageList.forEach((baggageIds: any) => {
        this.baggagesIds.push(baggageIds.$.BAGGAGEALLOWANCEID);
      });
    }
  }

  roundOfferPrice(value: string): string {
    let priceData = parseFloat(value);
    return priceData.toFixed(2);
  }

  mapToOfferPriceScreen() {
    let boundAirlineOffer: BoundAirlineOffer[] = [];
    let boundFlightList = this.flightList;
    let boundFlightIndex = 0;
    this.flightSegmentKey = 1;
    boundFlightList.forEach((boundFlight: any) => {
      boundAirlineOffer.push(this.mapFlightDetails(boundFlight.SEGMENTREFERENCES[0], boundFlightIndex));
      boundFlightIndex++;
    });
    //store passenger
    let totalPrice = 0;
    let totalTax = 0;
    let totalBasePrice = 0;
    let currencyCode = '';
    let offerPricePassengersDetails = this.offerPriceDataList.PASSENGERLIST[0].PASSENGER;

    let offerPricePassengerDetailsLength = offerPricePassengersDetails.length;
    let passengersDetails: Passenger[] = [];
    let pasengerCount = 0;
    if (offerPricePassengerDetailsLength > 0) {
      offerPricePassengersDetails.forEach((passenger: any) => {
        let passengerId = passenger.$.PASSENGERID;
        let basePrice = 0;
        let tax = 0;
        let price = 0;
        let currency: any = '';
        //mapping price for customer
        let offerList = this.offerPricePricedOffer.OFFERITEM;
        let offerListLength = offerList.length;
        if (offerListLength > 0) {
          let allowToAddPrice: boolean = true;
          offerList.forEach((offerList: any) => {
            let service = offerList.SERVICE;
            let serviceLength = service.length;
            if (serviceLength > 0) {
              service.forEach((serviceData: any) => {
                if (allowToAddPrice) {
                  let passengerRefs = serviceData.PASSENGERREFS[0].split(' ');
                  let serviceAvilableForpassenger: any = passengerRefs.indexOf(passengerId);
                  if (typeof serviceAvilableForpassenger !== 'undefined' && serviceAvilableForpassenger !== -1) {
                    let servicePriceDetail = offerList.FAREDETAIL[0].PRICE[0];
                    basePrice += +servicePriceDetail.BASEAMOUNT[0]._;
                    tax += +servicePriceDetail.TAXES[0].TOTAL[0]._;
                    price += +servicePriceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._;
                    currency = servicePriceDetail.TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0].$.CODE;
                    allowToAddPrice = false;
                    totalPrice += +price;
                    totalTax += +tax;
                    currencyCode = currency;
                    totalBasePrice += +servicePriceDetail.BASEAMOUNT[0]._;
                  }
                }
              });
            }
          });
        }
        //end
        let passengerDetails: Passenger = {
          passengerOtherDetails: {
            passengerTicketDetails: [],
            passengerBaggageDetails: [],
            passengerSeatDetails: [],
            passengerMealDetails: [],
            passengerProductClimateServiceDetail: [],
            passengerDisablityServiceDetail: [],
            passengerSelectedBaggageDetail: [],
            passengerSelectedMealDetails: [],
            passengerSelectedDisablityServiceDetail: [],
            passengerSelectedSeatDetails: [],
            passengerSelectedProductClimateServiceDetail: []
          },
          passengerStatus: true,
          basePrice: basePrice,
          taxPrice: tax,
          totalPrice: price,
          currency: currency,

          flightPrice: basePrice,
          flightTax: tax,
          flightTotal: price,
          flightCurrency: currency,

          passengerName: 'FNTEST' + this.alphabetsOrderName[pasengerCount],
          passengerSurName: 'LNTEST' + this.alphabetsOrderName[pasengerCount],
          passengerGender: 'Male',
          passengerNameTitle: 'Mr',
          passengerType: passenger.PTC[0],
          passengerId: passengerId,
          passengerDOB: passenger.BIRTHDATE[0],
          residenceCountryCode: passenger.RESIDENCECOUNTRYCODE[0]
        };
        if (typeof passenger.INFANTREF !== 'undefined') {
          passengerDetails.infantRef = passenger.INFANTREF[0];
        }
        if (typeof passenger.CITIZENSHIPCOUNTRYCODE !== 'undefined') {
          passengerDetails.cityzenShipCode = passenger.CITIZENSHIPCOUNTRYCODE[0];
        }
        passengersDetails.push(passengerDetails);
        pasengerCount++;
      });
    }
    let offerPriceDetail = this.offerPricePricedOffer['OFFERITEM'][0].FAREDETAIL[0].PRICE[0];
    let offerBasePriceDetail = offerPriceDetail.BASEAMOUNT?offerPriceDetail.BASEAMOUNT[0]:'';
    let offerTaxPriceDetail = offerPriceDetail.TAXES?offerPriceDetail.TAXES[0].TOTAL[0]:'';
    //end
    let offerRefDetail = this.offerPricePricedOffer.$;
    let priceDetail = this.offerPricePricedOffer.TOTALPRICE?this.offerPricePricedOffer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0]:'';
    this.offerPriceScreen.offerPrice = {
      boundAirlineOffer: boundAirlineOffer,
      priceDetail: {
        price: priceDetail._,
        currency: priceDetail.$.CODE,
        flightPrice: priceDetail._,
        seatPrice: '0',
        bagPrice: '0'
      },
      paymentLimitTime: this.offerPricePricedOffer.PAYMENTTIMELIMITDATETIME?this.offerPricePricedOffer.PAYMENTTIMELIMITDATETIME[0]:'',
      offerExpiration: this.offerPricePricedOffer.OFFEREXPIRATIONDATETIME?this.offerPricePricedOffer.OFFEREXPIRATIONDATETIME[0]:'',
      priceGuranteeExpiration: this.offerPricePricedOffer.PRICEGUARANTEETIMELIMITDATETIME?this.offerPricePricedOffer.PRICEGUARANTEETIMELIMITDATETIME[0]:'',
      offerId: offerRefDetail.OFFERID,
      owner: offerRefDetail.OWNER,
      responseId: this.offerScreenResponseId?this.offerScreenResponseId:'',
      baseAmount: offerBasePriceDetail._,
      baseCurrency: offerBasePriceDetail.$.CODE,
      taxAmount: offerTaxPriceDetail._,
      taxCurrency: offerTaxPriceDetail.$.CODE
    };
    this.passengerDetailScreen = {
      bookingPassengerDetailType: 'offer-price-screen-passenger',
      isMapped: true,
      passengerDetail: passengersDetails,
      totalTax: totalTax,
      totalPrice: totalPrice,
      totalBasePrice: totalBasePrice,
      currency: currencyCode,
      activePassengerIndex: 0
    };
    this.isOfferScreenMapped = true;
    this.displayConfirmBookingScreen = true;

    this.confirmBookingScreen.bookingType = 'pre-booking-form';
    this.confirmBookingScreen.primeBookingTicketDetail = {
      priceDetails: {
        flightPrice: totalPrice.toFixed(2),
        seatPrice: '0',
        bagPrice: '0',
        cardFee: '0',
        totalCharge: totalPrice.toFixed(2),
        priceCode: currencyCode
      }
    };

    this.offerPriceScreen.isMapped = true;
    this.offerPriceScreen.fareDetails = this.fareDetails.reverse();
    this.sandboxPageStateService.updateOfferPriceScreenData(this.offerPriceScreen);
    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreen);
    this.sandboxPageStateService.updateConfirmBookingScreenData(this.confirmBookingScreen);
    this.bookedClass = this.offerPriceScreen.offerPrice!.boundAirlineOffer[0].flightDetails[0].economyTypeLabel;
  }

  getEconomyDetail(economyDetail: any, flightRef: any) {
    let priceClassRef = economyDetail.PRICECLASSREF[0];
    let priceClassRefIndex: any = this.priceClassListIds.indexOf(priceClassRef);
    let economyName = '';
    let economyLabel = '';
    let economyCode = '';
    let fareCode = '';
    let fbCode = '';
    let priceClass = '';
    if (typeof priceClassRefIndex !== 'undefined') {
      let selectedPriceClass = this.priceClassList[priceClassRefIndex];
      economyName = selectedPriceClass.NAME[0];
      let classServiceList = selectedPriceClass.CLASSOFSERVICE;
      let classServiceListLength = classServiceList.length;
      if (classServiceListLength > 0) {
        classServiceList.forEach((classService: any) => {
          let classServiceRef = classService.$.REFS.split(' ');
          this.mapLongSellDetails(classServiceRef);
          let classServiceIndex: any = classServiceRef.indexOf(flightRef);
          if (typeof classServiceIndex !== 'undefined' && classServiceIndex !== -1) {
            let fareDetail = this.getFareCode(classServiceRef);
            priceClass = fareDetail.priceClass;
            fbCode = fareDetail.fbCode;
            fareCode = fareDetail.fareCode;
            economyLabel = classService.MARKETINGNAME[0]._;
            economyCode = classService.CODE[0];
          }
        });
      }
    }
    return { priceClass: priceClass, economyName: economyName, economyLabel: economyLabel, economyCode: economyCode, fareCode: fareCode, fbCode: fbCode };
  }

  mapLongSellDetails(classServiceRef: any) {
    let fareListData: ConfirmBookingFareList[] = [];
    classServiceRef.forEach((ref: any) => {
      this.fareGroupList.forEach((fareGroup: any) => {
        if (fareGroup.$.LISTKEY === ref) {
          fareListData.push(fareGroup);
          this.confirmBookingScreen.longsellDetails = {
            fareList: fareListData
          };
        }
      });
    });
  }

  getFareCode(fareCodes: any[]) {
    let result = { priceClass: '', fbCode: '', fareCode: '' };
    fareCodes.forEach((fareCode: any) => {
      let fareCodeIndex: any = this.fareGroupIds.indexOf(fareCode);
      if (fareCodeIndex !== -1) {
        let selectedFareGroup = this.fareGroupList[fareCodeIndex];
        this.fareDetails.push({
          $: {
            refs: selectedFareGroup.$.REFS,
            ListKey: selectedFareGroup.$.LISTKEY
          },
          Fare: {
            FareCode: selectedFareGroup.FARE[0].FARECODE[0]
          },
          FareBasisCode: {
            Code: selectedFareGroup.FAREBASISCODE[0].CODE[0]
          }
        });
        let adultRef = selectedFareGroup.$.REFS;
        if (adultRef === this.selectedAdultRefIds) {
          let code = selectedFareGroup.FAREBASISCODE[0].CODE[0];
          result.priceClass = code;
          result.fbCode = selectedFareGroup.$.LISTKEY;
          result.fareCode = selectedFareGroup.FARE[0].FARECODE[0];
        }
      }
    });
    return result;
  }

  getBagsDetails(offerPricePricedOffer: any) {
    let bagWeight: any = 0;
    let baggageCategory: any;
    let quantity: any = 0;
    let handbagLength: any = 0;
    let handbagWidth: any = 0;
    let handbagHeight: any = 0;
    let carryOnBagLength: any = 0;
    let carryOnBagWidth: any = 0;
    let carryOnBagHeight: any = 0;
    offerPricePricedOffer.BAGGAGEALLOWANCE.forEach((BAGGAGEALLOWANCE: any) => {
      let baggeRef = BAGGAGEALLOWANCE.BAGGAGEALLOWANCEREF[0];
      let baggageIndex = this.baggagesIds.indexOf(baggeRef);
      this.bags = this.baggageList[baggageIndex];
      this.bagQuantity = '0';
      if (this.bags.BAGGAGECATEGORY[0] === 'Checked') {
        if (typeof this.bags.PIECEALLOWANCE !== 'undefined') {
          this.bagQuantity = this.bags.PIECEALLOWANCE[0].TOTALQUANTITY[0];
          if (this.bagQuantity === '0') {
            this.baCheckBag = false;
          } else {
            this.baCheckBag = true;
            let checkedBagCount = 0;
            this.checkedBagCount.push(checkedBagCount++);
            if (typeof this.bags?.PIECEALLOWANCE[0].PIECEMEASUREMENTS[0].PIECEWEIGHTALLOWANCE !== 'undefined') {
              bagWeight = this.bags?.PIECEALLOWANCE?.PIECEMEASUREMENTS?.PIECEWEIGHTALLOWANCE?.MAXIMUMWEIGHT?.VALUE;
            }
          }
          if (this.bags.PIECEALLOWANCE[0].BAGTYPE[0] === 'Bag') {
            quantity = this.bags.PIECEALLOWANCE[0].TOTALQUANTITY[0];
            if (typeof this.bags?.PIECEALLOWANCE[0].PIECEMEASUREMENTS[0].PIECEWEIGHTALLOWANCE !== 'undefined') {
              bagWeight = this.bags?.PIECEALLOWANCE[0]?.PIECEMEASUREMENTS[0]?.PIECEWEIGHTALLOWANCE[0]?.MAXIMUMWEIGHT[0]?.VALUE[0];
            }
          }
        }
      }
      if (this.bags.BAGGAGECATEGORY[0] === 'CarryOn') {
        if (typeof this.bags.PIECEALLOWANCE !== 'undefined') {
          //  new code for bags
          this.bags.PIECEALLOWANCE.forEach((bagDetails: any) => {
            baggageCategory = this.bags.BAGGAGECATEGORY[0];
            if (bagDetails.BAGTYPE[0] === 'briefcase, laptop or handbag') {
              handbagLength = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[0]?.MAXVALUE[0];
              handbagWidth = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[1]?.MAXVALUE[0];
              handbagHeight = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[2]?.MAXVALUE[0];
            }
            if (bagDetails.BAGTYPE[0] === 'Bag') {
              carryOnBagLength = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[0]?.MAXVALUE[0];
              carryOnBagWidth = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[1]?.MAXVALUE[0];
              carryOnBagHeight = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[2]?.MAXVALUE[0];
            }
            if (bagDetails.BAGTYPE[0] === '1 additional cabin bag') {
              carryOnBagLength = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[0]?.MAXVALUE[0];
              carryOnBagWidth = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[1]?.MAXVALUE[0];
              carryOnBagHeight = bagDetails?.PIECEMEASUREMENTS[0]?.PIECEDIMENSIONALLOWANCE[0]?.DIMENSIONS[2]?.MAXVALUE[0];
            }
          });
          // new code for bags
          this.bagQuantity = this.bags.PIECEALLOWANCE[0].TOTALQUANTITY[0];
          if (this.bagQuantity === '0') {
            this.baCarryOnBag = false;
          } else {
            this.baCarryOnBag = true;
            let carryOnBagCount = 0;
            this.carryOnBagCount.push(carryOnBagCount++);
          }
        }
      }
      this.baggagePieceDimension = {
        bagLength: carryOnBagLength,
        bagWidth: carryOnBagWidth,
        bagHeight: carryOnBagHeight,
        bagWeight: bagWeight,
        baggageCategory: baggageCategory,
        quantity: quantity,
        handbagLength: handbagLength,
        handbagWidth: handbagWidth,
        handbagHeight: handbagHeight
      };
    });
  }

  mapFlightDetails(flightRefIds: any, boundFlightIndex: any) {
    let boundFlightSegmentList = this.flightSegmentList;
    let flightsDetails: FlightDetail[] = [];
    let boundFlightRefArray = flightRefIds.split(' ');

    // ----------------------------- rules mapping ---------------------------
    let postDepatureRules: Rule[] = [];
    let preDepatureRules: Rule[] = [];
    let noShowRules: Rule[] = [];
    if (this.fareRulesIds.length > 0) {
      let fareRulesIndex: any = this.fareRulesIds.indexOf(flightRefIds);
      let selectedFareSegment = this.fareRulesSegmentList[fareRulesIndex];
      if (typeof selectedFareSegment.FARERULES !== 'undefined') {
        let rulesRefsArr = selectedFareSegment.FARERULES[0].PENALTY[0].$.REFS.split(' ');
        rulesRefsArr.forEach((ruleRef: any) => {
          // this.refundableInd = "false";
          // this.changeFeeInd = "false";
          // this.cancelFeeInd = "false";
          let rulesIndex: any = this.rulesIds.indexOf(ruleRef);
          let selectedRules = this.rulesList[rulesIndex];
          if (typeof selectedRules.$.REFUNDABLEIND !== 'undefined') {
            this.refundableInd = selectedRules.$.REFUNDABLEIND;
          }
          if (typeof selectedRules.$.CHANGEFEEIND !== 'undefined') {
            this.changeFeeInd = selectedRules.$.CHANGEFEEIND;
          }
          if (typeof selectedRules.$.CANCELFEEIND !== 'undefined') {
            this.cancelFeeInd = selectedRules.$.CANCELFEEIND;
          }
          let details = selectedRules.DETAILS[0].DETAIL[0];
          let ruleType = details.APPLICATION[0];
          let ruleLabel = details.TYPE[0];
          let changePenaltyRemark = '';
          let cancellationPenaltyRemark = '';
          let changePenaltyAmount = '';
          let cancellationPenaltyAmount = '';
          let changeRuleLable = '';
          let cancellationRuleLabel = '';
          if (typeof details.AMOUNTS !== 'undefined') {
            let penaltyAmountDetail = details.AMOUNTS[0].AMOUNT[0].CURRENCYAMOUNTVALUE[0];
            let penaltyAmount = penaltyAmountDetail._ + '' + penaltyAmountDetail.$.CODE;
            if (ruleLabel === 'Change') {
              changeRuleLable = ruleLabel;
              changePenaltyRemark = 'Time/date changes permitted at any time before each flight departure for a change fee. ';
              changePenaltyAmount = penaltyAmount;
            } else if (ruleLabel === 'Cancellation') {
              cancellationRuleLabel = ruleLabel;
              cancellationPenaltyRemark = 'Cancelelation subject a fee. ';
              cancellationPenaltyAmount = penaltyAmount;
            }
          } else {
            if (ruleLabel === 'Change') {
              changeRuleLable = ruleLabel;
              changePenaltyRemark = 'No Changes are permitted';
            } else if (ruleLabel === 'Cancellation') {
              cancellationRuleLabel = ruleLabel;
              cancellationPenaltyRemark = 'There are no refunds except for any Government & airport taxes';
            }
          }
          let rule: Rule = {
            changeRuleLable: changeRuleLable,
            cancellationRuleLabel: cancellationRuleLabel,
            changePenaltyRemark: changePenaltyRemark,
            cancellationPenaltyRemark: cancellationPenaltyRemark,
            changePenaltyAmount: changePenaltyAmount,
            cancellationPenaltyAmount: cancellationPenaltyAmount
          };
          if (ruleType == '2') {
            preDepatureRules.push(rule);
          } else if (ruleType == '1') {
            noShowRules.push(rule);
          } else if (ruleType == '3') {
            postDepatureRules.push(rule);
          }
        });
      }
    }

    //------------------------------ rules mapping ---------------------------

    boundFlightRefArray.forEach((flightRef: any) => {
      let flightDetailIndex: any = this.flightSegmentIds.indexOf(flightRef);
      if (typeof flightDetailIndex !== 'undefined') {
        let selectedFlightDetail = boundFlightSegmentList[flightDetailIndex];
        let depatureDetail = selectedFlightDetail.DEPARTURE[0];
        let arrivalDetail = selectedFlightDetail.ARRIVAL[0];
        let marketingCarrier = selectedFlightDetail.MARKETINGCARRIER[0];
        let operatingCarrier = selectedFlightDetail.OPERATINGCARRIER[0];
        let fDetail = selectedFlightDetail.FLIGHTDETAIL[0];
        let fDuriation = fDetail.FLIGHTDURATION[0].VALUE[0];
        //map economy
        let fareComponent = this.offerPricePricedOffer.OFFERITEM[0].FAREDETAIL[0].FARECOMPONENT;
        let economyDetails: any = {};
        let boundFareComponent = fareComponent[boundFlightIndex];
        economyDetails = this.getEconomyDetail(boundFareComponent, flightRef);
        //end
        let iconsStatus: IconsStatus = {
          baChangesFee: this.changeFeeInd,
          baRefund: this.refundableInd,
          baHandBag: true,
          baCheckBag: this.baCheckBag,
          baCarryOnBag: this.baCarryOnBag,
          cancelFee: this.cancelFeeInd,
          remark: this.remarkText,
          baCheckBagCount: this.checkedBagCount,
          baCarryOnBagCount: this.carryOnBagCount
        };
        let flightDetail: FlightDetail = {
          segmentKey: 'F' + this.flightSegmentKey,
          flightRefs: flightRef,
          departureDate: this.datePipe.transform(depatureDetail.DATE[0], 'dd-MMM'),
          departureTimeIn24H: depatureDetail.TIME[0],
          departureAirportName: depatureDetail.AIRPORTNAME[0],
          departureAirportCode: depatureDetail.AIRPORTCODE[0],
          arrivalDate: this.datePipe.transform(arrivalDetail.DATE[0], 'dd-MMM'),
          segmentDepartureDate: this.datePipe.transform(arrivalDetail.DATE[0], 'dd-M-YYYY'),
          arrivalTimeIn24H: arrivalDetail.TIME[0],
          arrivalAirportName: arrivalDetail.AIRPORTNAME[0],
          arrivalAirportCode: arrivalDetail.AIRPORTCODE[0],
          airlineId: marketingCarrier.AIRLINEID[0],
          airlineName: marketingCarrier.NAME[0],
          airlineNumber: marketingCarrier.FLIGHTNUMBER[0],
          operatingCarrier: operatingCarrier.NAME[0],
          duriation: fDuriation.slice(2),
          priceClassCode: economyDetails.priceClass,
          economyCode: economyDetails.economyCode,
          economyType: economyDetails.economyName,
          economyTypeLabel: economyDetails.economyLabel,
          passengerSeatDetail: [],
          iconsStatus: iconsStatus,
          baggagePieceDimension: this.baggagePieceDimension,
          fbcode: economyDetails.fbCode,
          fareCode: economyDetails.fareCode,
          actualDepatureDate: depatureDetail.DATE[0],
          actualArrivalDate: arrivalDetail.DATE[0],
          flightType: ''
        };
        flightsDetails.push(flightDetail);
        this.flightSegmentKey++;
      }
    });

    let airlineOfferBase: AirlineOfferBase = {
      flightDetails: flightsDetails,
      postDepatureRules: postDepatureRules,
      preDepatureRules: preDepatureRules,
      noShowRules: noShowRules,
      displayRule: false
    };

    return airlineOfferBase;
  }
  toggleRule(boundOfferIndex: any) {
    if (this.offerPriceScreen.offerPrice.boundAirlineOffer[boundOfferIndex].displayRule) {
      this.offerPriceScreen.offerPrice.boundAirlineOffer[boundOfferIndex].displayRule = false;
    } else {
      this.offerPriceScreen.offerPrice.boundAirlineOffer[boundOfferIndex].displayRule = true;
    }
  }
  mapFareGroup(fareGroupList: any) {
    this.fareGroupIds = [];
    let fareGroupListLength = fareGroupList.length;
    if (fareGroupListLength > 0) {
      fareGroupList.forEach((fareGroup: any) => {
        this.fareGroupIds.push(fareGroup.$.LISTKEY);
      });
    }
  }
  mapPriceClass(priceClassList: any) {
    this.priceClassListIds = [];
    let priceClassListLength = priceClassList.length;
    if (priceClassListLength > 0) {
      priceClassList.forEach((priceClass: any) => {
        this.priceClassListIds.push(priceClass.$.PRICECLASSID);
      });
    }
  }
  mapFlightSegmentIds(flightSegmentList: any) {
    this.flightSegmentIds = [];
    let flightSegmentListLength = flightSegmentList.length;
    if (flightSegmentListLength > 0) {
      flightSegmentList.forEach((flightSegment: any) => {
        this.flightSegmentIds.push(flightSegment.$.SEGMENTKEY);
      });
    }
  }
  mapFlightIds(flightList: any) {
    this.flightIds = [];
    let flightListLength = flightList.length;
    if (flightListLength > 0) {
      flightList.forEach((flightSegment: any) => {
        this.flightIds.push(flightSegment.$.FLIGHTKEY);
      });
    }
  }

  offerPriceScreenCloseClick() {
    let patchSandboxSourceData = { mainMenu: 'airline-offers', sideMenu: 'filterOffer' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  //seat selection function
  async manageSeats(flightIndex: any, boundOfferIndex: any) {
    let offerId = this.offerPriceScreen.offerPrice.offerId;
    let owner = this.offerPriceScreen.offerPrice.owner;
    let responseId = this.offerPriceScreen.offerPrice.responseId;
    let flightSegmentNumber = '';
    let selectedFlight: any = this.offerPriceScreen.offerPrice.boundAirlineOffer[boundOfferIndex].flightDetails[flightIndex];
    flightSegmentNumber = selectedFlight.airlineId + selectedFlight.airlineNumber;
    let operatedBy = selectedFlight.operatingCarrier;
    if (!['BRITISH AIRWAYS', 'BA CITYFLYER', 'BA EUROFLYER'].includes(operatedBy?.toUpperCase())) {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: ' Unable to return seat map for the requested flight(s) - request seat at check-in' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      return;
    }
    const selectedSegmentQueryDetail = {
      Offer: {
        $: {
          OfferID: offerId,
          Owner: owner,
          ResponseID: responseId
        },
        SegmentID: flightSegmentNumber
      }
    };

    this.initOfferPriceScreenSeatSelectionRequest(selectedSegmentQueryDetail);

    await this.apiService.getXMLResponse(this.sandboxPageStateService.SEAT_SELECTION_SCREEN_URL, JSON.stringify(this.seatSelectionScreenRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'SeatAvailability17_2_V2'
      }),
      responseType: 'text'
    });

    let seatSelectionScreen: SeatSelectionScreen = {} as SeatSelectionScreen;

    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      seatSelectionScreen.xml = this.sandboxPageStateService.getResponseFromMap(this.sandboxPageStateService.SEAT_SELECTION_SCREEN_URL);
      (seatSelectionScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(seatSelectionScreen.xml!)), (seatSelectionScreen.boundOfferIndex = boundOfferIndex);
      seatSelectionScreen.flightSegmentIndex = flightIndex;
      seatSelectionScreen.flightNumber = flightSegmentNumber;
      seatSelectionScreen.bookingType = 'offer-price-screen-seat';
      seatSelectionScreen.passengerDetail = [];
      seatSelectionScreen.deckDetails = [];
      this.sandboxPageStateService.updateSeatSelectionScreenData(seatSelectionScreen);
      this.sandboxPageStateService.updateOfferPriceScreenData(this.offerPriceScreen);

      let patchSandboxSourceData = { mainMenu: 'seat-selection', sideMenu: 'none' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  initOfferPriceScreenSeatSelectionRequest(query: any) {
    const jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL);
    const airlineOffersScreenRequest: AirlineOffersScreenRequest = JSON.parse(jsonRequest);
    this.seatSelectionScreenRequest['S:Envelope'] = {} as SEnvelopeSeatSelection;
    this.seatSelectionScreenRequest['S:Envelope'].$ = {};
    this.seatSelectionScreenRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.seatSelectionScreenRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.seatSelectionScreenRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body'] = {} as SBodySeatSelection;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ = {} as SeatAvailabilityRQ;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$ = {};
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.$.Version = '17.2';
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Document = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Document;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Party = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Party;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.Query = query;
    this.seatSelectionScreenRequest['S:Envelope']['S:Body']!.SeatAvailabilityRQ.DataLists = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.DataLists;
  }
  //end

  selectOtherOffer(offerIndex: any) {
    let selectedOffer = this.availableOtherOffers[offerIndex];

    let airLineOfferScreenData: AirlineOffersScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    let responseID = airLineOfferScreenData.responseID;

    let priceDetailData: PriceDetail = {} as PriceDetail;
    priceDetailData.price = selectedOffer.price;
    priceDetailData.currency = selectedOffer.currency;
    let offerItem: any[] = [];

    selectedOffer.offItemList.forEach((offerItemDetails: any) => {
      offerItem.push({
        offerItemID: offerItemDetails.offerItemID,
        passengerRefs: offerItemDetails.passengerRefs
      });
    });

    let otherAirlineOffer: AirlineOffer = {} as AirlineOffer;
    otherAirlineOffer.offerIndex = NaN;
    otherAirlineOffer.offerOwner = selectedOffer.owner;
    otherAirlineOffer.offerItem = offerItem;

    otherAirlineOffer.offerId = selectedOffer.offerID;
    otherAirlineOffer.priceDetail = priceDetailData;
    this.initOtherOffersScreenRequest(otherAirlineOffer, responseID);
  }

  async initOtherOffersScreenRequest(selectedOffer: AirlineOffer, responseID: string) {
    let searchFlightFormValue = this.sandboxPageStateService.getSearchFlightFormValue();
    let isShortSell = searchFlightFormValue.shortSell;
    let boundOffers = selectedOffer.boundAirlineOffer;
    const searchFlightJSONRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.SEARCH_FLIGHTS_SCREEN_URL);
    const searchFlightsScreenRequest: SearchFlightsScreenRequest = JSON.parse(searchFlightJSONRequest);
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.AIRLINE_OFFER_TEMPLATE);
    this.airlineOffersScreenRequest = JSON.parse(jsonRequestTemplate as any);
    this.airlineOffersScreenRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.airlineOffersScreenRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.airlineOffersScreenRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$.Version = '17.2';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Document = searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Document;
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Party = searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Party;
    if (isShortSell) {
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.Offer = {
        $: {
          OfferID: selectedOffer.offerId,
          Owner: selectedOffer.offerOwner,
          ResponseID: responseID
        },
        OfferItem: this.mapOfferPriceScreenQuery(selectedOffer.offerItem)
      };
    } else {
      delete this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.Offer;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem = {} as OrderItem;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem.OfferItemID = {
        $: {
          Owner: selectedOffer.offerOwner
        },
        _: 'Offer1'
      };
      if (isShortSell) {
        this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem.OfferItemType = {
          DetailedFlightItem: {
            OriginDestination: this.loadOfferPriceRequestOrigin(boundOffers)
          }
        };
      } else {
        this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem.OfferItemType = {
          DetailedFlightItem: {
            OriginDestination: this.loadOfferPriceRequestOriginLongsell(boundOffers)
          }
        };
      }
    }

    if (searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference['FarePreferences'] === undefined) {
      let farePreferences = {} as Preference;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Preference = farePreferences;
    } else {
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Preference.FarePreferences!.Types =
        searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference.FarePreferences!.Types;
    }
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.PassengerList.Passenger = [];
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.PassengerList.Passenger = this.getSearchAirlinepassenger();
    if (!isShortSell) {
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.FareList = {} as FareList;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.FareList.FareGroup = [];
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.FareList.FareGroup = this.loadFareGroup(boundOffers);
    }
    await this.apiService.getXMLResponse(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL, JSON.stringify(this.airlineOffersScreenRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'OfferPrice17_2_V2'
      }),
      responseType: 'text'
    });
    this.updateOfferPriceScreenXML(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL, selectedOffer);
  }

  loadOfferPriceRequestOrigin(boundOffers: OtherBoundAirlineOffer[]) {
    let originDestination: OriginDestination[] = [];
    let boundOffersLength = boundOffers.length;
    if (boundOffersLength > 0) {
      let flightsDetail: Flight[] = [];
      boundOffers.forEach((boundOffer: OtherBoundAirlineOffer) => {
        boundOffer.flightDetails.forEach((flightDetail: OtherFlightDetail) => {
          let flightMapResult = this.mapOfferRequestFlightDetail(flightDetail);
          flightsDetail.push(flightMapResult);
        });
      });
      originDestination.push({
        Flight: flightsDetail
      });
    }
    return originDestination;
  }
  loadOfferPriceRequestOriginLongsell(boundOffers: OtherBoundAirlineOffer[]) {
    let originDestination: OriginDestination[] = [];
    let boundOffersLength = boundOffers.length;
    if (boundOffersLength > 0) {
      boundOffers.forEach((boundOffer: OtherBoundAirlineOffer) => {
        let flightsDetail: Flight[] = [];
        boundOffer.flightDetails.forEach((flightDetail: OtherFlightDetail) => {
          let flightMapResult = this.mapOfferRequestFlightDetail(flightDetail);
          flightsDetail.push(flightMapResult);
        });
        originDestination.push({
          Flight: flightsDetail
        });
      });
    }
    return originDestination;
  }
  mapOfferRequestFlightDetail(flightDetail: OtherFlightDetail) {
    let mapFlightDetail: Flight = {
      Departure: {
        AirportCode: flightDetail.departureAirportCode,
        Date: flightDetail.actualDepatureDate,
        Time: flightDetail.departureTimeIn24H
      },
      Arrival: {
        AirportCode: flightDetail.arrivalAirportCode,
        Date: flightDetail.actualArrivalDate
      },
      MarketingCarrier: {
        AirlineID: flightDetail.airlineId,
        FlightNumber: flightDetail.airlineNumber
      },
      ClassOfService: {
        $: {
          refs: flightDetail.fbcode
        },
        Code: flightDetail.flightType
      }
    };
    return mapFlightDetail;
  }
  loadFareGroup(boundOffers: OtherBoundAirlineOffer[]) {
    this.mappedSelectedOfferPriceFareCode = [];
    let boundOffersLength = boundOffers.length;
    let fareGroup: OtherFareGroup[] = [];
    if (boundOffersLength > 0) {
      boundOffers.forEach((boundOffer: OtherBoundAirlineOffer) => {
        boundOffer.flightDetails.forEach((flightDetail: OtherFlightDetail) => {
          let fareGroupMapResult = this.mapOtherOfferFareGroup(flightDetail);
          if (fareGroupMapResult.isMapped) {
            fareGroup.push(fareGroupMapResult.fareGroup);
          }
        });
      });
    }
    return fareGroup;
  }
  mapOtherOfferFareGroup(flightDetail: OtherFlightDetail) {
    let isCodeMapped: any = this.mappedSelectedOfferPriceFareCode.indexOf(flightDetail.fbcode);

    let fareFroupData = { isMapped: false, fareGroup: {} as OtherFareGroup };
    if (isCodeMapped === -1) {
      this.mappedSelectedOfferPriceFareCode.push(flightDetail.fbcode);
      let fareGroup: OtherFareGroup = {
        $: {
          ListKey: flightDetail.fbcode
        },
        Fare: {
          FareCode: flightDetail.flightCode2
        },
        FareBasisCode: {
          Code: flightDetail.flightCode1
        }
      };
      fareFroupData.isMapped = true;
      fareFroupData.fareGroup = fareGroup;
    }
    return fareFroupData;
  }
  getSearchAirlinepassenger() {
    let airLineOfferScreenData: AirlineOffersScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    let passengerList = airLineOfferScreenData.passengerList;
    let infantRefsids = airLineOfferScreenData.infantRefsIds;
    let passengerLength = passengerList.length;
    let passengersDetail: OtherPassenger[] = [];
    if (passengerLength > 0) {
      let i = 0;
      passengerList.forEach((passenger: AirlineOfferPassenger) => {
        let passengerDetail: OtherPassenger = {
          $: {
            PassengerID: passenger.passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          ResidenceCountryCode: this.sandboxPageStateService.getAgentResidenceCountryCode(),
          CitizenshipCountryCode: this.sandboxPageStateService.getCitizenshipCountryCode()
        };
        if (typeof infantRefsids[i] !== 'undefined' && passengerDetail.PTC === 'ADT') {
          passengerDetail.InfantRef = infantRefsids[i];
        }
        passengersDetail.push(passengerDetail);
        i++;
      });
    }
    return passengersDetail;
  }

  mapOfferPriceScreenQuery(offerItem: OfferItems[]) {
    let offerItemsList: airLineOfferRequestOfferItem[] = [];
    offerItem.forEach((offer: any) => {
      let offerItemList: airLineOfferRequestOfferItem = {
        $: {
          OfferItemID: offer.offerItemID
        },
        PassengerRefs: offer.passengerRefs
      };
      offerItemsList.push(offerItemList);
    });
    return offerItemsList;
  }

  updateOfferPriceScreenXML(url: string, selectedOffer: AirlineOffer) {
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let offerPriceScreen: OfferPriceScreen = {} as OfferPriceScreen;
      offerPriceScreen.isMapped = false;
      offerPriceScreen.selectedBagOfferItem = {
        offerId: '',
        owner: '',
        responseId: '',
        offerDetail: []
      };
      offerPriceScreen.selectedSeatItem = [];

      offerPriceScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      offerPriceScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(offerPriceScreen.xml!);

      offerPriceScreen.selectedOfferId = selectedOffer.offerId;
      offerPriceScreen.selectedOfferOwner = selectedOffer.offerOwner;
      offerPriceScreen.selectedOfferItem = selectedOffer.offerItem;
      let sandboxData = this.sandboxPageStateService.getSandboxPage();
      sandboxData.isUpsellOfferSelected = true;
      this.sandboxPageStateService.updateSandboxPage(sandboxData);
      this.sandboxPageStateService.updateOfferPriceScreenData(offerPriceScreen);
      let patchSandboxSourceData = { mainMenu: 'offer-price', sideMenu: 'none' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      this.ngOnInit();
    }
  }

  pricedifference(oldPrice: any, newPrice: any) {
    return Math.round(oldPrice - newPrice);
  }

  mapOtherOffers(otheroffers: any) {
    this.availableOtherOffers = [];
    otheroffers.forEach((offer: any) => {
      let otherOffer = {} as UpsellOffers;
      if (typeof offer !== 'undefined') {
        otherOffer.offerID = offer.$.OFFERID;
        otherOffer.owner = offer.$.OWNER;
        otherOffer.baggageAllowanceID = offer.BAGGAGEALLOWANCE.filter((bagID: any) => bagID.BAGGAGEALLOWANCEREF[0]);

        otherOffer.price = offer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0]._;
        otherOffer.currency = offer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0].$.CODE;
        otherOffer.offItemList = [];
        offer.OFFERITEM.forEach((offerItem: any) => {
          otherOffer.offItemList.push({
            offerItemID: offerItem.$.OFFERITEMID,
            passengerRefs: offerItem.SERVICE[0].PASSENGERREFS[0]
          });
        });

        let priceClassID = offer.OFFERITEM[0].FAREDETAIL[0].FARECOMPONENT[0].PRICECLASSREF[0];

        let priclassArray = this.priceClassList.filter((data: any) => data.$.PRICECLASSID === priceClassID);
        otherOffer.economyTypeName = priclassArray[0].NAME[0];
        if (priclassArray[0].DESCRIPTIONS) {
          otherOffer.priceClassDescriptions = priclassArray[0].DESCRIPTIONS[0].DESCRIPTION;
        }
        otherOffer.offerItemID;
      }
      this.availableOtherOffers.push(otherOffer);
    });

    this.sandboxPageStateService.updateUpsellOffersData(this.availableOtherOffers);
  }
}
